export function formatCurrency(num: number): string | number {
    if (!num) {
        return 0
    }
    return Number(num)
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, '$&,')
}

export function GetLocalStorage (params: string) {
    const storageItem = localStorage.getItem(params);
    if(!storageItem) return;
    return JSON.parse(storageItem);
};

export function numberShortener(num: number, digits: number): string {
    const lookup = [
        { value: 1, symbol: "" },
        { value: 1e3, symbol: "k" },
        { value: 1e6, symbol: "M" },
        { value: 1e9, symbol: "G" },
        { value: 1e12, symbol: "T" },
        { value: 1e15, symbol: "P" },
        { value: 1e18, symbol: "E" }
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    const item = lookup.slice().reverse().find(function(item) {
        return num >= item.value;
    });
    return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
}

export function urlify(text: string) {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.replace(urlRegex, function(url) {
        return '<a href="' + url + '" target="_blank">' + url + '</a>';
    })
}

export function truncateString(str: string , n: number){
    if(!str || str.length === 0) return "";
    return (str.length > n) ? str.slice(0, n-1) + '...' : str;
};